import React from "react";
import type { Illustration } from "../util";
import { illustrationProps } from "../util";

export const InvoiceConnectionError: Illustration = (props) => (
  <svg viewBox="0 0 157 125" {...illustrationProps(props, { width: 157 })}>
    <path
      fill="#D2D8FF"
      d="M77.441 2.128c30.897 0 55.944 25.047 55.944 55.944 0 2.661-.187 5.28-.546 7.842a29.201 29.201 0 0 0-6.786-.796c-16.083 0-29.121 13.038-29.121 29.12 0 5.34 1.437 10.343 3.945 14.645a55.724 55.724 0 0 1-23.436 5.132c-30.896 0-55.943-25.046-55.943-55.943S46.545 2.128 77.441 2.128Z"
    />
    <mask
      id="a"
      width="113"
      height="113"
      x="21"
      y="2"
      maskUnits="userSpaceOnUse"
      style={{ maskType: "alpha" }}
    >
      <path
        fill="#D2D8FF"
        d="M77.442 2.128c30.896 0 55.943 25.047 55.943 55.944 0 2.661-.187 5.28-.547 7.842a29.194 29.194 0 0 0-6.786-.797c-16.083 0-29.12 13.038-29.12 29.122 0 5.339 1.438 10.341 3.946 14.644a55.743 55.743 0 0 1-23.436 5.132c-30.897 0-55.944-25.046-55.944-55.943S46.545 2.128 77.442 2.128Z"
      />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#4D5BE0"
        d="M97.697 78.99c0 .836-.428 1.51-.953 1.51H58.139c-.526 0-.954-.674-.954-1.51V37.447c0-.836.428-1.51.954-1.51h38.605c.525 0 .953.674.953 1.51V78.99Z"
      />
      <path fill="#97A1FF" d="M51.109 48.091h8.102v20.256h-8.102z" />
      <rect
        width="14.854"
        height="6.752"
        x="47.733"
        y="68.347"
        fill="#97A1FF"
        rx="2.026"
      />
      <path fill="#97A1FF" d="M94.321 48.091h8.102v20.256h-8.102z" />
      <rect
        width="14.854"
        height="6.752"
        x="90.945"
        y="68.347"
        fill="#97A1FF"
        rx="2.026"
      />
      <path fill="#97A1FF" d="M72.716 48.091h8.102v20.256h-8.102z" />
      <rect
        width="14.854"
        height="6.752"
        x="69.34"
        y="68.347"
        fill="#97A1FF"
        rx="2.026"
      />
      <path
        fill="#97A1FF"
        d="M74.351 21.451 41.978 41.44c-1.83 1.13-1.029 3.95 1.122 3.95h68.589c2.158 0 2.953-2.836 1.109-3.958l-32.87-19.999a5.336 5.336 0 0 0-5.577.018ZM107.152 75.099a2.7 2.7 0 0 1 2.699 2.7v5.402H45.033V77.8a2.7 2.7 0 0 1 2.7-2.701h59.419Z"
      />
      <path
        fill="#97A1FF"
        d="M112.302 83.201a1.6 1.6 0 0 1 1.6 1.6v4.901a1.6 1.6 0 0 1-1.6 1.601h-69.72a1.6 1.6 0 0 1-1.6-1.6v-4.901a1.6 1.6 0 0 1 1.6-1.601h69.72Z"
      />
      <rect
        width="14.854"
        height="6.752"
        x="47.733"
        y="45.39"
        fill="#7C7FFF"
        rx="2.026"
      />
      <rect
        width="14.854"
        height="6.752"
        x="90.945"
        y="45.39"
        fill="#7C7FFF"
        rx="2.026"
      />
      <rect
        width="14.854"
        height="6.752"
        x="69.339"
        y="45.39"
        fill="#7C7FFF"
        rx="2.026"
      />
      <path
        fill="#7C7FFF"
        d="M107.151 79.15a2.7 2.7 0 0 1 2.699 2.7v1.35H45.032v-1.35a2.7 2.7 0 0 1 2.7-2.7h59.419Z"
      />
      <circle cx="77.266" cy="33.341" r="6.137" fill="#7C7FFF" />
    </g>
    <circle cx="126.053" cy="94.238" r="25.364" fill="#FF9494" />
    <path
      fill="#fff"
      stroke="#fff"
      strokeLinecap="round"
      strokeWidth=".939"
      d="M118.036 84.025a2.114 2.114 0 1 0-2.989 2.989l8.413 8.413-8.413 8.413a2.112 2.112 0 1 0 2.989 2.989l8.413-8.413 8.413 8.413a2.112 2.112 0 1 0 2.989-2.989l-8.413-8.413 8.413-8.413a2.113 2.113 0 1 0-2.989-2.99l-8.413 8.414-8.413-8.413Z"
    />
  </svg>
);
